// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"68":"3f3087a5","423":"bc86795f","466":"8782a9ce","476":"9e6bc15b","591":"852e025f","665":"04a095de","927":"d1c86598","931":"a79ca88f"}[chunkId] + ".js";
};